<template>
  <v-data-table :headers="headers" :items="filteredClients" sort-by="name" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Clientes</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Novo Cliente</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.name" label="Nome"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.gender" label="Sexo"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.phone" label="Telefone"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.birth_date" label="Data de Nascimento"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Clients",
  data() {
    return {
      search: "",
      dialog: false,
      headers: [
        {
          text: "Nome",
          align: "start",
          sortable: false,
          value: "name"
        },
        {
          text: "Email",
          sortable: false,
          value: "email"
        },
        {
          text: "Sexo",
          sortable: false,
          value: "gender"
        },
        {
          text: "Telefone",
          sortable: false,
          value: "phone"
        },
        {
          text: "Data de Nascimento",
          sortable: false,
          value: "birth_date"
        },
        { text: "Ações", value: "actions", sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        name: ""
      },
      defaultItem: {
        name: ""
      }
    };
  },
  methods: {
    ...mapActions(["fetchClients"]),
    initialize() {},
    editItem(item) {
      this.editedIndex = this.filteredClients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.filteredClients.indexOf(item);
      confirm("Eliminar Cliente?") && this.filteredClients.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        //Editado
        // Object.assign(this.filteredClients[this.editedIndex], this.editedItem);
      } else {
        //Novo
        // this.filteredClients.push(this.editedItem);
      }
      this.close();
    }
  },
  computed: {
    ...mapGetters(["allClients"]),
    filteredClients: function() {
      return this.allClients.filter(client => {
        return client.name.match(this.search) || client.phone.match(this.search);
      });
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Tratamento" : "Editar Tratamento";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.fetchClients();
  }
};
</script>

<style>
#clients {
  width: 100%;
  margin-top: 15px;
  padding-bottom: 10px;
}

#clients td,
#clients th {
  border: 1px solid #ddd;
  padding: 8px;
}

#clients tr:nth-child(even) {
  background-color: #f2f2f2;
}

#clients tr:hover {
  background-color: #ddd;
}

#clients th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;

  color: black;
}
</style>
